import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, InputGroup, FormControl, ProgressBar } from 'react-bootstrap';
import { CHAINS } from '../config/env'
import { getAccount, getChainId, setChainId } from '../hooks/useAccount'
import { SocialmediaUpdate } from '../hooks/useAdmin';


class Socialmediamodal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saleAddress: window.location.pathname.split('/')[2],
            socialModal: true,
            logo:props.saleInfo.logo,
            banner: props.saleInfo.banner,
            description: props?.saleInfo?.description,
            website: props?.saleInfo?.social[0],
            twitter: props.saleInfo.social[1],
            telegram: props.saleInfo.social[2],
            name: props.saleInfo.social[3],
            symbol: props.saleInfo.social[4],
            githup: props.saleInfo.social[5],
            instagram: props.saleInfo.social[6],
            discord: props.saleInfo.social[7],
            reddit: props.saleInfo.social[8],
            youtube: props.saleInfo.social[9]
      
        };
    }
    
    async Socialmedia() {
        const data = [
            this.state.description ? this.state.description : "#",
            this.state.website ? this.state.website : "#",
             this.state.twitter ? this.state.twitter :"#",
             this.state.telegram ? this.state.telegram :"#",
             this.state.name ? this.state.name :"#",
             this.state.symbol ? this.state.symbol :"#",
             this.state.githup ? this.state.githup : "#",
             this.state.instagram ? this.state.instagram : "#",
             this.state.discord ?this.state.discord :"#",
             this.state.reddit ? this.state.reddit :"#",
             this.state.youtube ? this.state.youtube :"#",
             this.state.logo ? this.state.logo : "#",
            //  this.state.banner ? this.state.banner : "#",
             
        ]
        console.log("dattaaaaaaaaaaa",data);
       const response = await SocialmediaUpdate(data,this.state.saleAddress, getAccount());
      //  await this.refreshData()
if(response == true){
    this.props.onDismiss()
    window.location.reload()
}
    
      }
    render() {
        const { socialModal } = this.state
       // {console.log("prposs___",this.props,this.state)}
        return (

            <Modal className="buy-modal social_modal" dialogClassName="modal-90w modal-dialog-lg" show={socialModal} centered>
                <Modal.Header className='pt-3 header_odal_head'>
                    <h3 className="sec-head ">SOCIAL MEDIA EDIT</h3>
                    <button type="button" class="close" onClick={() => this.props.onDismiss()} ><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-cont pb-4">
                        {/* <p class="bottom_text nettxt">SOCIAL MEDIA</p> */}
                        
                        <div className='row mx-0'>

                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Logo URL *</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                value={this.state.logo}
                                onChange = {e => this.setState({logo : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                 
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Banner URL*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.banner}
                                 onChange = {e => this.setState({banner : e.target.value})}
                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Website*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.website}
                                 onChange = {e => this.setState({website : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Twitter*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.twitter}
                                 onChange = {e => this.setState({twitter : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Github*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.githup}
                                 onChange = {e => this.setState({githup : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Telegram*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.telegram}
                                 onChange = {e => this.setState({telegram : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Instagram*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.instagram}
                                 onChange = {e => this.setState({instagram : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                         <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Discord*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.discord}
                                 onChange = {e => this.setState({discord : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Reddit*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.reddit}
                                 onChange = {e => this.setState({reddit : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Youtube Video*</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.youtube}
                                 onChange = {e => this.setState({youtube : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>

                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Description *</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="tokenaddress" placeholder=""
                                aria-describedby="basic-addon2"
                                 value={this.state.description}
                                 onChange = {e => this.setState({description : e.target.value})}                            />
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.tokenaddress}</span>
                    </div>
                  
                        </div>
                   

                        <div className='col-12 col-md-12 text-center'>
                                                        <button className="get-started-btn explore-btn mr-2"
                                                        onClick={()=>this.Socialmedia()}
                                                            >
                                                            Submit
                                                        </button>
                                                        </div>

                        </div>


                    </div>
                </Modal.Body>

            </Modal>
        )
    }

}


export default Socialmediamodal